// app.syncsimple.ai — confirmed live and serving hook.sh (2026-09-06) — is
// this app's real production domain: it's what vite.config.ts's
// allowedHosts and lib/supabase.ts's OAuth redirect base already treat as
// canonical, and what `npm run deploy` (wrangler pages deploy) ships to.
// See InstallClaudeCode.tsx's history comment for the earlier UAT-only state.
// 2026-10-02: hook.mjs (v0.3.0, Node 18+) replaced hook.sh (v0.2.0, now
// deprecated but still served for old installs). install.sh 1.1.0 installs it.
export const DEFAULT_HOOK_URL = 'https://app.syncsimple.ai/install/claude-code/hook.mjs'

export const HOOK_URL =
  (import.meta.env.VITE_HOOK_URL as string | undefined) || DEFAULT_HOOK_URL

// Same public host as HOOK_URL — install.sh lives alongside hook.mjs and
// downloads it itself, so the two must stay in sync.
export const DEFAULT_INSTALL_URL = 'https://app.syncsimple.ai/install/claude-code/install.sh'

export const INSTALL_URL =
  (import.meta.env.VITE_INSTALL_URL as string | undefined) || DEFAULT_INSTALL_URL

// 2026-09-06 redesign: replaces the old 9-step natural-language prompt (an
// LLM was asked to interpret free text and hand-merge JSON into
// settings.json — the riskiest step of that flow) with a single
// `curl | bash` command the member runs directly in their own terminal.
// The command's one argument is a short-lived, single-use CLAIM CODE, never
// the real install token — see claim-install-token's header comment for why
// the token itself must never appear in a human-typed command line.
export function buildInstallCommand(claimCode: string): string {
  return `curl -fsSL ${INSTALL_URL} | bash -s -- ${claimCode}`
}

export function buildHookUpdateCommand(): string {
  return `curl -fsSL ${INSTALL_URL} | bash -s -- --update`
}

export async function extractFunctionErrorMessage(error: unknown): Promise<string> {
  try {
    const withContext = error as { context?: { json?: () => Promise<unknown> } }
    const body = (await withContext.context?.json?.()) as
      | { error?: { message?: string } }
      | undefined
    if (body?.error?.message) return body.error.message
  } catch {
    // Ignore parse failures and fall back to a generic message.
  }

  const withMessage = error as { message?: string }
  return withMessage?.message || 'Something went wrong. Please try again.'
}
